import React from 'react';
import { userAppData } from '../MainApp.js';
import './Dashboard.css';
import '../alert/Alert.css';

import DashboardLinks from './DashboardLinks.js';
import QuickLinks from './QuickLinks.js';
import DashboardRotas from './DashboardRotas.js';
import DashboardNotifications from './DashboardNotifications.js';





export default function Dashboard() {
  const activeAlerts = Array.isArray(userAppData?.alert?.activeAlerts) ? userAppData.alert.activeAlerts : [];

  const openAlertUrl = (url) => {
    if (!url) {
      return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className='main_div'>
      <div className='internal_main_div'>
        {activeAlerts.length > 0 && (
          <div className="dashboard-alert-wrapper">
            <div className="dashboard-alert-banner" role="alert">
              {activeAlerts.map((activeAlert) => {
                const bgColour = activeAlert.bgColour || '#706f6f';
                const textColour = activeAlert.textColour || '#ffffff';
                return (
                  <div
                    className="alert-active-card dashboard-alert-card"
                    key={activeAlert.alertId || activeAlert.title}
                    style={{ backgroundColor: bgColour, color: textColour, borderColor: textColour }}
                  >
                    <div className="alert-active-text">
                      <p className="alert-active-kicker" style={{ color: textColour }}>Active Alert</p>
                      <h2 className="alert-active-title" style={{ color: textColour }}>{activeAlert.title || 'Active alert in progress'}</h2>
                      {activeAlert.subtitle && (
                        <p className="alert-active-body" style={{ color: textColour }}>{activeAlert.subtitle}</p>
                      )}
                    </div>
                    {activeAlert.alertUrl && (
                      <button
                        type="button"
                        className="dashboard-alert-button"
                        style={{ backgroundColor: bgColour, color: textColour, borderColor: textColour }}
                        onClick={() => openAlertUrl(activeAlert.alertUrl)}
                      >
                        GO TO ALERT PAGE
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
        <div className='dashboard_main_div'>
          <div className='dashboard_column_div'>
            <DashboardNotifications />
            <QuickLinks />
            <DashboardRotas />
          </div>
          <div className='dashboard_column_div'>
            <DashboardLinks />
          </div>

        </div>
      </div>
    </div>
  )
};
